import { createFileRoute } from "@tanstack/react-router";
import ArticlesPage from "@/pages/ArticlesPage";
export const Route = createFileRoute("/articles")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Articles & Resources | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Search our educational articles and clinical resources on SAINT® TMS, depression, anxiety, treatment-resistant depression, and advanced mental health.",
        },
        {
          property: "og:title",
          content: "Articles & Resources | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Search our educational articles and clinical resources on SAINT® TMS, depression, anxiety, treatment-resistant depression, and advanced mental health.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/articles",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/articles",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ArticlesPage />;
}
